interface InfoModalPayload {
  erpItemNumber: string
  title: string
  titleLong: string
  descriptionShort: string
  articleUrl: string
  attributes: any
  imgSrc: string
}

export const getInfoModalPayload = (
  _editorial: any,
  assetBaseUrl: string,
  langMarketCode: 'sv-SE-BYME' | 'nb-NO-GF' | 'sv-FI-NR' | 'fi-FI-NR' | 'nb-NO-BYME' | '',
  attributes: any,
  erpItem: any
): InfoModalPayload => {
  const titleOrSku = erpItem?.Title || erpItem?.Sku

  const title = erpItem ? titleOrSku : _editorial?.title?.[langMarketCode]

  const titleLong = erpItem
    ? erpItem.TitleLong && _editorial
      ? `${erpItem.TitleLong}, ${_editorial.titleExtension[langMarketCode]}`
      : erpItem.TitleLong
    : _editorial?.titleLong?.[langMarketCode]

  const descriptionShort = erpItem?.DescriptionShort ?? _editorial?.descriptionShort?.[langMarketCode]

  const imgSrc = _editorial?.noppeImageId
    ? //@ts-expect-error // TODO:, does _internalId exist on window?
      `${assetBaseUrl}/mediaarchive/s2/images/${erpItem ? titleOrSku : _internalId}/${_editorial.noppeImageId}`
    : `${assetBaseUrl}/mediaarchive/s/images/${titleOrSku}/${erpItem.Sku}`

  return {
    erpItemNumber: erpItem?.Sku ?? '',
    title: title ?? '',
    titleLong: titleLong ?? '',
    descriptionShort: descriptionShort ?? '',
    articleUrl: erpItem?.ArticleUrl ?? '',
    attributes,
    imgSrc,
  }
}
